module.exports = __webpack_public_path__ + "media/images/talent/lp/mv02-92003e0a45d68909135ff741a6822bda.png";